const items = [
  "PURI BEACH",
  "JAGANNATH DHAM",
  "KONARK SUN TEMPLE",
  "CHILIKA LAKE DOLPHINS",
  "CHANDUA APPLIQUÉ CRAFT",
  "SCOOTY ₹250 A DAY",
  "OUTSTATION CABS @ ₹20/KM",
  "LOCAL RIDES @ ₹75/KM",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div className="bg-surface py-5 overflow-hidden border-y border-ink/10" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-serif text-lg sm:text-xl tracking-wide text-ink/90">
            <span className="px-6">{item}</span>
            <span className="text-terra">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
